import { render, staticRenderFns } from "./GuideDefault.vue?vue&type=template&id=13d48a80&"
import script from "./GuideDefault.vue?vue&type=script&lang=js&"
export * from "./GuideDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports